import { UserOrgs } from './organization';
import { Role } from './role';


export interface IUser {
    Id: number;
    FirstName: string;
    LastName: string;
    Gender: string;
}

export class User {
    public Id: number;
    public firstName = '';
    public lastName = '';
    public middleName = '';
    public jobTitle = '';
    public phoneNumber = '';
    public phoneNumberExtension = '';
    public Roles: Role[];
    public Organizations: UserOrgs[];
    public orgsList = '';
    public rolesList = '';
    public fax = '';
    public faxExtension = '';
    public emailAddress = '';
    public phoneNumber2 = '';
    public phoneNumber2Extension  = '';
    public IsActive = false;
    public IsEnabled = false;
    public note = '';
    public userName = '';
    public currentOrg: number;
}
